
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { LuckyValueModel } from "../../model/lottery/LotteryModel";
import LotteryImageToast from "../lottery/LotteryImageToast.vue";
import ValueAnimation from "../../components/lottery/ValueAnimation.vue";
import RedeemPrizesToast from "../../components/lottery/RedeemPrizesToast.vue";
import { openToast } from "toast-ts";
@Options({
  components: {
    LotteryImageToast,
    ValueAnimation,
    RedeemPrizesToast
  }
})
export default class LuckyValue extends Vue {
  private luckyValue: LuckyValueModel | null = null;
  private toastImageShow = false;
  private redeemPrizesShow = false;
  private luckyValueText = "";
  private luckyValueHeight = 55; // 55 ~ 0
  mounted() {
    this.getLuckyValue();
  }
  //TODO:添加字段满100 是否兑换了商品
  getLuckyValue() {
    Http.post<LuckyValueModel>(Urls.lottery_getLuckyValue, null).then(
      (res: LuckyValueModel) => {
        this.luckyValue = res;
        this.setValueData();
      },
      (err: ResponseData) => {
        console.log("LuckyValue", err.message);
        openToast(err.message);
      }
    );
  }
  setValueData() {
    if (this.luckyValue == null) return;
    if (this.luckyValue.num >= 100) {
      this.luckyValueHeight = 0;
    } else {
      this.luckyValueHeight = 55 - this.luckyValue.num * 0.55;
    }
    if (this.luckyValue != null && this.luckyValue.num >= 100) {
      this.luckyValueText = "兑换";
    } else {
      this.luckyValueText = "幸运值";
    }
  }
  exchangeImage(value: boolean) {
    this.toastImageShow = value;
  }
  exchangeLuckyValue(value: boolean) {
    console.log(value);
    if (this.luckyValueText == "兑换") {
      this.redeemPrizesShow = true;
    } else {
      this.redeemPrizesShow = false;
    }
  }
  reloadData() {
    this.redeemPrizesShow = false;
    this.getLuckyValue();
  }
}
